import { render, staticRenderFns } from "./ZnNewCompany.vue?vue&type=template&id=72943b91"
import script from "./ZnNewCompany.vue?vue&type=script&lang=js"
export * from "./ZnNewCompany.vue?vue&type=script&lang=js"
import style0 from "./ZnNewCompany.vue?vue&type=style&index=0&id=72943b91&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports